import React from 'react';

const GroupIcon = () => (
  <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_214_1870)">
      <path
        d="M14.5497 9.87927C13.7827 9.87927 13.0471 9.57458 12.5048 9.03222C11.9624 8.48986 11.6577 7.75426 11.6577 6.98724C11.6577 6.22023 11.9624 5.48463 12.5048 4.94227C13.0471 4.39991 13.7827 4.09521 14.5497 4.09521C15.3168 4.09521 16.0524 4.39991 16.5947 4.94227C17.1371 5.48463 17.4418 6.22023 17.4418 6.98724C17.4418 7.75426 17.1371 8.48986 16.5947 9.03222C16.0524 9.57458 15.3168 9.87927 14.5497 9.87927Z"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M8.76562 18.5552V17.8322C8.76562 16.6817 9.22267 15.5783 10.0362 14.7647C10.8497 13.9512 11.9531 13.4941 13.1037 13.4941H15.9957C17.1462 13.4941 18.2496 13.9512 19.0632 14.7647C19.8767 15.5783 20.3337 16.6817 20.3337 17.8322V18.5552"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M4.79389 6.64718C4.34028 6.19357 4.08545 5.57835 4.08545 4.93685C4.08545 4.29535 4.34028 3.68012 4.79389 3.22651C5.2475 2.7729 5.86273 2.51807 6.50423 2.51807C7.14573 2.51807 7.76095 2.7729 8.21456 3.22651"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M1.66699 14.6118V14.0071C1.66699 13.0448 2.04924 12.122 2.72966 11.4416C3.41007 10.7612 4.33291 10.3789 5.29516 10.3789H6.50455"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_214_1870">
        <rect
          width="21.3333"
          height="21.3333"
          fill="white"
          transform="translate(0.333496 0.333252)"
        />
      </clipPath>
    </defs>
  </svg>
);

export default GroupIcon;
